angular.module('Itao.IndicatorMap').directive('barChart', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  var sortedAccessor = function (d, i) {
    return i;
  };
  var combineData = function (layer, indicators, selectedDistricts, disabledDistrictKeys) {
    var selectedUids = selectedDistricts.map(function (district) {
      return district.uid;
    });
    var data = [];
    for (var districtUid in layer.districts) {
      if (layer.hasOwnProperty(districtUid) && disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1) {
        var valueArray = indicators.map(function (indicator) {
          // '+' for cast to number
          return {value: +layer[districtUid][indicator.uid], key: indicator.key};
        });
        data.push({
          key: layer.districts[districtUid].key,
          name: layer.districts[districtUid].name,
          hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
          values: valueArray,
          selected: selectedUids.indexOf(districtUid) !== -1
        });
      }
    }
    return data;
  };

  var calculateMaxValue = function (data) {
    return d3.max(data.map(function (current) {
      return d3.max(current.values, accessor('value'));
    }));
  };

  var calculateMinValue = function (data) {
    return d3.min(data.map(function (current) {
      return d3.min(current.values, accessor('value'));
    }));
  };

  var barChart = function () {
    var indicators = [],
      disabledIndicators = [],
      districtLabelProperty = 'key',
      displayValues = false,
      decimals,
      maxAxisValue,
      svgHeight = 200,
      color = d3.hyperion.indicatorColorAt,
      redLines = null,
      redLinesMinMaxMode = false,
      margin = {top: 40, right: 10, bottom: 40, left: 50},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      tip;

    var chart = function (selection) {
      selection.each(function (data) {
        var filteredIndicators = indicators.filter(function (indicator) {
          return disabledIndicators.indexOf(indicator.key) === -1;
        });

        //calculate min and max values and check that 0 is included
        var minValue = calculateMinValue(data);
        var maxValue = calculateMaxValue(data);
        if (minValue > 0) {
          minValue = 0;
        }
        if (maxValue < 0) {
          maxValue = 0;
        }

        if (maxAxisValue) {
          maxValue = maxAxisValue;
        } else if (mapConfig.axisMaxValue != null) {
          maxValue = mapConfig.axisMaxValue;
        }

        var axisFormatString = ',.' + (decimals ? decimals : (maxValue < 7 ? '1' : '0')) + 'f';

        //calculate the space needed for the y-axis labels
        var labelDigits = Math.max((filteredIndicators[0].prefix + germanNumberFormat(axisFormatString)(Math.round(maxValue))).length, (filteredIndicators[0].prefix + germanNumberFormat(axisFormatString)(Math.round(minValue))).length);
        margin.left = 20 + 10 * labelDigits;

        var districtLabelDigits = d3.max(data.map(function (d) {
          return accessor(districtLabelProperty)(d).length;
        }));

        margin.bottom = 15 + 7 * districtLabelDigits;
        margin.bottom = Math.min(svgHeight / 2, margin.bottom);

        var container = d3.select(this).datum([data]).classed('bar-chart', true);

        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        var colorFromBar = compose(color, function (d, i) {
          return indicators.map(accessor('key')).indexOf(filteredIndicators[i].key);
        });

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, indicatorNumber, districtNumber) {
            if (!decimals) {
              decimals = filteredIndicators[indicatorNumber].unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            var district = data[districtNumber], value;
            if (filteredIndicators[indicatorNumber].unit === '%') {
              value = filteredIndicators[indicatorNumber].prefix + germanNumberFormat(',.' + decimals + 'f')(d.value) + '%';
            } else {
              value = filteredIndicators[indicatorNumber].prefix + germanNumberFormat(',.' + decimals + 'f')(d.value);
            }
            return '<div class="d3-tip-border" style="border-color:' + colorFromBar(d, indicatorNumber) + ';"><b>' + district.name + ' (' + district.key + ')</b><br><span>' + filteredIndicators[indicatorNumber].name.replace('<br/>', '').replace('<br>', '').trim() + ':</span> <span class="tooltip-value">' + value + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for districts
        var x0 = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.3)
          .domain(data.map(accessor(districtLabelProperty)));

        // scale for each bar per district
        var x1 = d3.scale.ordinal()
          .domain(filteredIndicators.length < 2 ? [0] : d3.range(filteredIndicators.length)) // use only active indicators
          .rangeRoundBands([0, x0.rangeBand()]);

        redLines = redLines ? redLines : mapConfig.redLines.filter(function (lineValue) {
          return lineValue <= maxValue;
        });

        // scale for bar values
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxValue])
          .nice();

        var tickCount = Math.min(svgHeight / 40, 10);

        g.call(d3.hyperion.addHorizontalGridLines(y, width, 0, tickCount, duration));

        var xAxis = d3.svg.axis()
          .scale(x0)
          .orient('bottom');

        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(tickCount)
          .tickFormat(function (d) {
            return filteredIndicators[0].prefix + germanNumberFormat(axisFormatString)(d);
          });

        gEnter.append('g')
          .attr('class', 'x axis');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('text-anchor', districtLabelDigits > 4 ? 'end' : 'middle')
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          })
          .attr('dx', districtLabelDigits > 4 ? '-.8em' : '')
          .attr('dy', '.15em')
          .attr('transform', districtLabelDigits > 4 ? 'rotate(-65)' : '');

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .transition().duration(duration)
          .call(yAxis);

        // only draw bars if indicators are left
        if (angular.isArray(filteredIndicators) && filteredIndicators.length > 0) {
          if (!redLinesMinMaxMode) {
            g.call(d3.hyperion.addHorizontalHighlightArea(redLines, y, x0, width, duration));
          } else {
            g.call(d3.hyperion.addHorizontalMinMaxHighlightArea(redLines, y, x0, width, duration));
          }

          var unit = indicators[0].unit;

          svgEnter.append('text')
            .attr('class', 'axis-unit-label')
            .attr('text-anchor', 'end')
            .attr('transform', 'translate(' + (margin.left - 7) + ',10)');

          svg.select('.axis-unit-label')
            .text(unit === '%' ? 'in %' : '');

          // create a feature per district
          var features = g.selectAll('.feature')
            .data(data, accessor('key'));

          features
            .enter().append('g')
            .classed('feature', true)
            .attr('stroke', 'black');

          features
            .attr('transform', function (d) {
              return 'translate(' + x0(d[districtLabelProperty]) + ')';
            })
            .attr('stroke-width', function (d) {
              return accessor('selected')(d) ? '2px' : '0px';
            });

          var bars = features.selectAll('rect')
            .data(accessor('values'), accessor('key'));

          // draw new bars
          bars
            .enter()
            .append('rect')
            .style('fill', colorFromBar)
            .attr('width', 0)
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', y(0))
            .attr('height', 0);

          // update all bars
          bars
            .transition().duration(duration)
            .style('fill', colorFromBar)
            .attr('width', x1.rangeBand())
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', function (d) {
              return y(Math.max(0, accessor('value')(d)));
            })
            .attr('height', function (d) {
              return Math.abs(y(0) - y(accessor('value')(d)));
            });

          // add tooltips to bars
          bars.call(tip);
          bars.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          // remove unused bars
          bars.exit().transition().duration(duration)
            .attr('width', 0)
            .attr('y', y(0))
            .attr('height', function () {
              return height - y(0);
            })
            .remove();

          var labels = features.selectAll('text')
            .data(accessor('values'), accessor('key'));

          if (displayValues) {
            // new labels
            labels
              .enter()
              .append('text')
              .attr('y', y(0))
              .attr('stroke-width', '0');

            // update labels
            labels
              .transition().duration(duration)
              .attr("class", "chart-value")
              .text(function (d) {
                if (accessor('unit')(d) === '%') {
                  return germanNumberFormat('.' + mapConfig.relativeIndicatorsDecimalPlaces + 'f')(accessor('value')(d)) + '%';
                } else {
                  // if (accessor('unit')(d) === "m&#178;") {
                  //   var unitSign = "m²";
                  // } else {
                  //   var unitSign = accessor('unit')(d);
                  // }
                  // var unitSign = indicators[0].unit;
                  var unitSign = '';
                  return germanNumberFormat('.' + mapConfig.absoluteIndicatorsDecimalPlaces + 'f')(accessor('value')(d)) + unitSign;
                }
              })
              .attr('x', function (d, i) {
                return (x1.rangeBand() / 2) + (x1.rangeBand() * i);
              })
              .attr('y', function (d) {
                return y(Math.max(0, accessor('value')(d))) - 4;
              });

            // remove unused labels
            labels.exit().transition().duration(duration)
              .attr('y', y(0))
              .remove();
          } else {
            labels.transition().duration(duration)
              .attr('y', y(0))
              .remove();
          }
          features.exit().remove();

          g.selectAll('line.highlightLine').remove();
          g.call(d3.hyperion.addHorizontalHighlightLines(redLines, y, width, duration, redLinesMinMaxMode));
        } else {
          // remove all bars if no indicators are active
          g.selectAll('rect').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for disabledIndicators
     * @param {int} [newDisabledIndicators] set of disabled indicators
     * @returns {*}
     */
    chart.disabledIndicators = function (newDisabledIndicators) {
      if (!arguments.length) {
        return disabledIndicators;
      } else {
        disabledIndicators = newDisabledIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [districtLabelProperty] name of property to use for districtlabels
     * @returns {*}
     */
    chart.districtLabelProperty = function (newdistrictLabelProperty) {
      if (!arguments.length) {
        return districtLabelProperty;
      } else {
        districtLabelProperty = newdistrictLabelProperty;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for color
     * @param {Function} [newColor] new color function
     * @returns {*}
     */
    chart.color = function (newColor) {
      if (!arguments.length) {
        return color;
      } else {
        color = newColor;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for redLinesMinMaxMode
     * @param {Function} [newRedLinesMinMaxMode] new redLinesMinMaxMode function
     * @returns {*}
     */
    chart.redLinesMinMaxMode = function (newRedLinesMinMaxMode) {
      if (!arguments.length) {
        return redLinesMinMaxMode;
      } else {
        redLinesMinMaxMode = newRedLinesMinMaxMode;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    return element.closest('.grid-stack-item-content-barChart').height() - jQuery(element).find('chart-indicator-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'barChart.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      disabledDistrictKeys: '=',
      selectedChartColorset: '=',
      indicators: '=',
      colorsets: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.disabledIndicators = scope.config.disabledIndicators || [];
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.config.displayValues = scope.config.displayValues || false;
      scope.config.fullscreen = scope.config.fullscreen || false;

      var barChartFunction = barChart();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }

        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }
        var indicators = scope.indicators.filter(function (indicator) {
          return indicator.hasShapeData;
        });

        var filteredIndicators = indicators.filter(function (indicator) {
          return scope.config.disabledIndicators.indexOf(indicator.key) === -1;
        });

        var color;
        var redLines = null;
        var redLinesMinMaxMode = null;
        var decimals = null;
        var maxAxisValue = null;

        if (scope.layer.legend != null) {
          color = d3.hyperion.buildColorFunction(filteredIndicators.map(function (indicator) {
            if (scope.layer.legend[indicator.uid] && scope.layer.legend[indicator.uid].chart) {
              var legend = scope.layer.legend[indicator.uid].chart;

              var colorsetUid = legend.colorSet;
              var indicatorColorSet = scope.colorsets.filter(function (colorSet) {
                return +colorSet.uid === +colorsetUid;
              })[0];

              if (legend && legend.redLines) {
                redLines = legend.redLines;
                redLinesMinMaxMode = legend.redLinesMinMaxMode;
              }

              if (legend && legend.decimals) {
                decimals = legend.decimals;
              }

              if (legend && legend.maxAxisValue) {
                maxAxisValue = legend.maxAxisValue;
              }

              var indicatorColor = '';
              if (indicatorColorSet != null) {
                indicatorColor = indicatorColorSet.colors[0].color;
              }

              return indicatorColor;
            } else {
              return d3.hyperion.indicatorColorAt;
            }
          }));
        } else if (scope.selectedChartColorset) {
          color = d3.hyperion.buildColorFunction(scope.selectedChartColorset.colors.map(function (color) {
            return color.color;
          }));
        } else {
          color = d3.hyperion.indicatorColorAt;
        }

        var data = combineData(scope.layer, filteredIndicators, scope.selectedDistricts, scope.disabledDistrictKeys);
        barChartFunction
          .color(color)
          .indicators(indicators)
          .redLines(redLines)
          .redLinesMinMaxMode(redLinesMinMaxMode)
          .districtLabelProperty(scope.config.districtLabelProperty)
          .disabledIndicators(scope.config.disabledIndicators)
          .displayValues(scope.config.displayValues)
          .decimals(decimals)
          .maxAxisValue(maxAxisValue)
          .height(newHeight);

        d3.select(element.find('.widget-inner:first')[0])
          .data([data])
          .call(barChartFunction);
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watch('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var disabledIndicators = scope.$watchCollection('config.disabledIndicators', rerender);
      var districtLabelPropertyWatcher = scope.$watchCollection('config.districtLabelProperty', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });
      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        disabledIndicators();
        districtLabelPropertyWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();

        // remove tooltip dom element
        if (angular.isDefined(barChartFunction.tip())) {
          barChartFunction.tip().destroy();
        }
      });
    }
  };
});
